import { ReactNode } from "react";
import ViewController from "../../commons/base/view_controller";
import WasteViewModel from "./view_models/waste_view_model";
import SizedDiv from "../../commons/ui/sized_div";
import TableWasteForms from "./widgets/table_waste_forms";
import TableWasteItems from './widgets/table_waste_items';
import LocationSelection from "./widgets/location_selection";
import Scaffold from "../../commons/scaffold/scaffold";
import "./style.css"
import FormButton from "../../commons/ui/form_button";
import WasteScreenState from "./view_models/waste_state";

interface Props {}

export default class WasteScreen extends ViewController<
    Props,
    WasteScreenState,
    WasteViewModel
> {
    constructor(props: Props) {
        super(props, new WasteViewModel());
    }

    componentDidMount(): void {
        window.addEventListener("popstate", (e) => {
            if (this.vmState.selectedLocationId !== undefined) {
                // previous page was the history table
                e.preventDefault();
                this.toLocationSelection();
            } else {
                window.history.back();
            }
        });
    }

    setSelectedFormState(formId: number) {
        this.viewModel.emit((lastState) => {
            lastState.selectedForm = formId;
            this.viewModel.updateTables();
            return lastState;
        })
    }

    toLocationSelection() {
        this.viewModel.resetAllState();
        const host = window.location.host.slice(0, window.location.host.length);
        const pathname = window.location.pathname;
        const newUrl = `http://${host}${pathname}`;
        window.history.pushState({path: newUrl}, "",newUrl);
    }

    renderMainContent(): ReactNode {
        return this.vmState.selectedLocationId
        ?   <div id="WasteScreenContainer">
                <div>
                    <div id="WasteHistoryContainer">
                        <SizedDiv height={100} />
                        <p className="FormTitle">
                            Riwayat Submit Form Waste {this.vmState.selectedLocation}
                        </p>
                        <div style={{display: "flex", alignItems: "start"}}>
                            <FormButton
                                action={(e) => {
                                    e.preventDefault();
                                    this.toLocationSelection();
                                }}
                                title="Kembali"
                                backgroundColor="#58BAD7"
                                textColor="#FFF"
                                borderColor="#FFF"
                            />
                        </div>
                        <SizedDiv height={30} />
                        <div className="FormTableContainer">
                            <TableWasteForms 
                                location={this.vmState.selectedLocationId}
                                forms={this.vmState.wasteForms} 
                                onBtnViewItemsClicked={(formId: number) => {
                                    this.setSelectedFormState(formId);
                                }}/>
                        </div>
                    </div>
                    <div id="WasteItemsContainer">
                        <p style={{fontWeight: "bold", fontSize: 24}}>
                            Daftar Item Pada Form Waste #{this.vmState.selectedForm}
                        </p>
                        <div className="ItemTableContainer">
                            <TableWasteItems formItems={this.vmState.wasteFormItems}/>
                        </div>
                    </div>
                </div>
            </div>
        :   <div id="LocationSelectionContainer">
                <div>
                    <p className="FormTitle">Pilih Lokasi Riwayat Submit Form Waste</p>
                    <SizedDiv height={30} />
                    <LocationSelection vc={this}/>
                </div>
            </div>  
    }

    render(): ReactNode {
        return (
            <Scaffold>
                {this.renderMainContent()}
            </Scaffold>
        );
    }
}
